import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

import { ChangeOrderComment, CommentListResponse } from '../../../interfaces/ChangeOrderComment';

/*
 * GraphQL Query for fetching the list of quote change order comments.
 */
export const listQuoteChangeOrderCommentsQuery = gql`
  query quoteCOListComments($changeOrderId: ID!, $maxResults: Int, $nextToken: String) {
    quoteCOListComments(changeOrderId: $changeOrderId, maxResults: $maxResults, nextToken: $nextToken) {
      comments {
        conversationId
        changeOrderId
        message
        visibility
        author
        createdAt
      }
      nextToken
    }
  }
`;

interface ListQuoteChangeOrderCommentsInput {
  changeOrderId: string;
  maxResults?: number;
  nextToken?: string;
}

interface ListQuoteChangeOrderCommentsResponse {
  quoteCOListComments: CommentListResponse;
}

export async function listQuoteChangeOrderComments(
  client: ApolloClient<object>,
  input: ListQuoteChangeOrderCommentsInput
): Promise<CommentListResponse> {
  try {
    const response = await client.query<ListQuoteChangeOrderCommentsResponse>({
      query: listQuoteChangeOrderCommentsQuery,
      variables: {
        changeOrderId: input.changeOrderId,
        maxResults: input.maxResults || 100,
        nextToken: input.nextToken
      },
      fetchPolicy: 'network-only'
    });

    // Data should always exist, even if comments array is empty
    if (!response.data?.quoteCOListComments) {
      throw new Error('No data returned from query');
    }

    return response.data.quoteCOListComments;

  } catch (err) {
    throw new Error(`Failed to list quote change order comments: ${err}`);
  }
}
